// 物料审查状态查询器
import React, { useState } from "react"
import Select from "@material-ui/core/Select"
import MenuItem from "@material-ui/core/MenuItem"
import FormControl from "@material-ui/core/FormControl"
import FormHelperText from "@material-ui/core/FormHelperText"

interface ComponentProps {
    onSelectStatus: (status: string) => void
}

const statusMap = {
    unfinished: "未定稿",
    finished: "定稿",
    unfilled: '未填写',
}

const StatusSelect = (props: ComponentProps) => {
    const { onSelectStatus } = props
    const [status, setStatus] = useState("")
    return (
        <FormControl>
            <Select
                displayEmpty
                value={status}
                onChange={(e: React.ChangeEvent<{ value: unknown }>) => {
                    const status = e.target.value as string
                    onSelectStatus(status)
                    setStatus(status)
                }}>
                <MenuItem value="">
                    <em>请选择</em>
                </MenuItem>
                {
                    Object.entries(statusMap).map(([key, value]) => (
                        <MenuItem key={key} value={key}>{value}</MenuItem>
                    ))
                }
            </Select>
            <FormHelperText>请选择状态</FormHelperText>
        </FormControl>
    )
}

export default StatusSelect
